import src from "IMAGE";
export default { src, width: 230, height: 94, blurWidth: 0, blurHeight: 0};
